module.exports = __webpack_public_path__ + "static/media/6.af825415.jpg";